import React from "react";

const ArrowDown = (props: any) => {
  return (
    <svg width={16} height={16} fill="none" {...props}>
      <path
        stroke="var(--color-icon-bright)"
        d="m13.28 5.967-4.346 4.346a1.324 1.324 0 0 1-1.867 0L2.721 5.967"
      />
    </svg>
  );
};

export default ArrowDown;
